import { CommonGet, CommonPost, CommonGetIDServer } from "../../../utils/CommonFetch";


export default {
    saveTask,
    editTask,
    getGroups,
    getEstatesByGroupID,
    getAllByFilter,
    getTaskTypes,
    GetAllOperationEntityByGroupID
};

async function saveTask(data){
   const formData = {
    estateTaskId: parseInt(data.estateTaskId),
    estateTaskName: data.estateTaskName,
    groupId: parseInt(data.groupID),
    operationEntityId: parseInt(data.operationEntityID),
    taskTypeID:parseInt(data.taskTypeID),
    estateTaskDescription: data.estateTaskDescription,
    createdBy: 0,
    createdDate: new Date().toISOString(),
    isActive: data.isActive,

   }
   var result = await CommonPost('/api/EstateTask/SaveTask', null, formData);

   return result;
}

async function editTask(data) {
    const formData = {
        estateTaskId:parseInt(data.estateTaskId),
        groupId: parseInt(data.groupID),
        operationEntityId: parseInt(data.operationEntityID),
        taskTypeID:parseInt(data.taskTypeID),
        estateTaskName: data.estateTaskName,
        estateTaskDescription: data.estateTaskDescription,
        createdBy: 0,
        createdDate: new Date().toISOString(),
        modifiedBy: 0,
        modifiedDate: new Date().toISOString(),
        isActive: data.isActive,

    }
    var result = await CommonPost('/api/EstateTask/Update', null, formData);

    return result;
}

async function getAllByFilter(groupId, operationEntityId) {
    var response = await CommonGet('/api/EstateTask/GetEstateTaskByFilter', 'groupID=' + groupId + '&operationEntityID=' + operationEntityId );
    return response.data;
}

async function GetAllOperationEntityByGroupID(groupID) {
    const dataArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllOperationEntityByGroupID', 'groupID=' + groupID);
    for (let item of Object.entries(response.data)) {
        dataArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
    }
    return dataArray;
}

async function getGroups() {
    let response = await CommonGet('/api/Group/GetAllGroups', null);
    let groupArray = []
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}


async function getEstatesByGroupID(groupID) {
    const response = await CommonGet('/api/OperationEntity/GetAllEstates', null);
    let array = []
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true && item[1]["groupID"] == groupID) {
        array[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        }
    }
    return array;
}
async function getTaskTypes() {
    var response = await CommonGet('/api/EnumData/GetTaskTypeEnumData', null );
    let array = []
    for (let item of Object.entries(response.data)) {
        array[item[1]["key"]] = item[1]["value"]
    }
    return array;
}
